export var UploadFileType;
(function (UploadFileType) {
  UploadFileType["LOCAL"] = "local";
  UploadFileType["URL"] = "url";
  UploadFileType["MEDIA_ID"] = "media_id";
})(UploadFileType || (UploadFileType = {}));
export var UploadStatus;
(function (UploadStatus) {
  UploadStatus["DEFAULT"] = "default";
  UploadStatus["SUCCESS"] = "success";
  UploadStatus["ERROR"] = "error";
  UploadStatus["UPLOADING"] = "uploading";
  UploadStatus["REMOVED"] = "removed";
})(UploadStatus || (UploadStatus = {}));